import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
// Views
const Dashboard = () => import("@/views/Dashboard");
// Views - CORE UI
const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

//const Charts = () => import("@/views/Charts");
const Widgets = () => import("@/views/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
// const Forms = () => import('@/views/base/Forms')
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const Flags = () => import("@/views/icons/Flags");
const FontAwesome = () => import("@/views/icons/FontAwesome");
const SimpleLineIcons = () => import("@/views/icons/SimpleLineIcons");
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

//##########################################################
//여기부터 코딩임

const User = () => import("@/views/yysoft/user/User");
const ScenarioBuild = () => import("@/views/yysoft/scenario/ScenarioBuild");
const ScenarioBuildDetails = () =>
  import("@/views/yysoft/scenario/ScenarioBuildDatails");
const ScenarioBuildCreate = () =>
  import("@/views/yysoft/scenario/ScenarioBuildCreate");

const Product = () => import("@/views/yysoft/product/Product");
const Facility = () => import("@/views/yysoft/facility/Facility");
const Team = () => import("@/views/yysoft/team/Team");
const Organization = () => import("@/views/yysoft/organization/Organization");
const DataTemplate = () => import("@/views/yysoft/template/DataTemplate");
// vonst DataTemplate = () => import
const Dataupload = () => import("@/views/yysoft/template/DataUpload");
const Acl = () => import("@/views/yysoft/security/AccessControl");
// security/acl

const TraceLot = () => import("@/views/yysoft/trace/Trace");
const TraceBarcord = () => import("@/views/yysoft/trace/TraceContainer");
const TraceDistributon = () => import("@/views/yysoft/trace/TraceDistribution");
const TraceNavigator = () => import('@/views/yysoft/trace/TraceNavigator')

const Recoding = () => import("@/views/yysoft/form/record/RecordingList");
const RecodingDetails = () =>
  import("@/views/yysoft/form/record/RecordingListDatails");

const Onboarding = () => import("@/views/yysoft/form/status/OnboardingList");
const OnboardingDetails = () =>
  import("@/views/yysoft/form/status/OnboardingListDatails");

const Members = () => import("@/views/yysoft/member1/member");

const Barcodes = () => import("@/views/barcode/Barcodes");
const GenerateBarcode = () => import("@/views/barcode/GenerateBarcode");
const AddNewQrcode = () => import("@/views/barcode/AddNewQrcode");
const AddNewPackageModal = () =>
  import("@/views/barcode/AddNewPackageModal.vue");
const packingtypeList = () => import("@/views/barcode/PackingtypeList");
const qrcodetypeList = () => import("@/views/barcode/QrcodetypeList");


const CreateOrg = () => import("@/views/yysoft/organization/CreateOrg");
const ListOrg = () => import("@/views/yysoft/organization/ListOrg");
Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  // linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  // linkActiveClass: "active",
  // linkExactActiveClass: "exact-active",
  routes: [
    {
      path: "/",
      // redirect: '/pages/login',
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      meta: { authRequired: true },
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: { authRequired: true },
        },
        {
          path: "user",
          // redirect: '/user/info',
          name: "Users",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "info",
              name: "Info",
              component: User,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
            {
              path: "members",
              name: "members",
              component: Members,
            },
          ],
        },
        {
          path: "onboarding",
          // redirect: '/user/info',
          name: "Onboarding",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: { authRequired: true },
          children: [
            {
              path: "product",
              name: "Product",
              component: Product,
              meta: { authRequired: true },
            },
            {
              path: "facility",
              name: "Facility",
              component: Facility,
              meta: { authRequired: true },
            },
            ,
            {
              path: "team",
              name: "Team",
              component: Team,
              meta: { authRequired: true },
            },
            {
              path: "organization",
              name: "Organization",
              component: Organization,
              meta: { authRequired: true },
            },
          ],
        },
        {
          path: "template",
          // redirect: '/user/info',
          name: "Template",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "upload",
              name: "Data-upload",
              component: Dataupload,
              meta: { authRequired: true },
            },
            {
              path: "spreadsheet",
              name: "Spreadsheet",
              component: DataTemplate,
              meta: { authRequired: true },
            },
          ],
        },
        {
          path: "scenario",
          redirect: "scenario/build",
          name: "Scenario",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "build",
              name: "Build",
              component: ScenarioBuild,
              meta: { authRequired: true },
              children: [],
            },
            {
              path: "build/details",
              name: "Details",
              component: ScenarioBuildDetails,
              props: true,
            },
            {
              path: "build/create",
              name: "create",
              component: ScenarioBuildCreate,
              props: true,
            },
          ],
        },
        {
          path: "trace",
          // redirect: '/user/info',
          name: "Trace",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "lot",
              name: "Trace Lot",
              component: TraceLot,
              props: true,
            },
            {
              path: "barcord",
              name: "Trace Barcord",
              component: TraceBarcord,
              props: true,
            },
            {
              path: "distribution",
              name: "Trace Distribution",
              component: TraceDistributon,
              props: true,
            },
            {
              path: "navigator",
              name: "Trace Navigator",
              component: TraceNavigator,
              props: true,
            },
          ],
        },
        {
          path: "forms",
          // redirect: '/user/info',
          name: "Forms",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "recording",
              name: "Recording",
              component: Recoding,
              props: true,
              children: [],
            },
            {
              path: "recording/details",
              name: "details",
              component: RecodingDetails,
              props: true,
            },
            {
              path: "onboarding",
              name: "Onboarding",
              component: Onboarding,
              props: true,
              children: [],
            },
            {
              path: "onboarding/details",
              name: "details",
              component: OnboardingDetails,
              props: true,
            },
          ],
        },
        {
          path: "security",
          // redirect: '/user/info',
          name: "Security",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "acl",
              name: "AccessControl",
              component: Acl,
              props: true,
            },
          ],
        },
        // {
        //   path: '/user/info', // 사용자 등록
        //   name: 'userinfo',
        //   component: BigdataFileDownloadTarget,
        //   meta: {authRequired: true}
        // },
        {
          path: "barcode",
          name: "Barcode",
          redirect: "/barcode/history",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "history",
              name: "Barcode",
              component: Barcodes,
              props: true,
            },
            {
              path: "generate",
              name: "GenerateBarcode",
              component: GenerateBarcode,
              props: true,
            },
            {
              path: "add-package",
              name: "AddNewPackage",
              component: AddNewPackageModal,
              props: true,
            },
            {
              path: "add-qrcode",
              name: "AddNewQrcode",
              component: AddNewQrcode,
              props: true,
            },
            {
              path: "package/list",
              name: "packingtypeList",
              component: packingtypeList,
              props: true,
            },
            {
              path: "qrcode/list",
              name: "qrcodetypeList",
              component: qrcodetypeList,
              props: true,
            },
          ],
        },
       // {
       //   path: "charts",
       //   name: "Charts",
       //   component: Charts,
       // },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },
        // {
        //   path: 'users',
        //   meta: { label: 'Users'},
        //   component: {
        //     render (c) { return c('router-view') }
        //   },
        //   children: [
        //     {
        //       path: '',
        //       component: Users,
        //     },
        //     {
        //       path: ':id',
        //       meta: { label: 'User Details'},
        //       name: 'User',
        //       component: User,
        //     },
        //   ]
        // },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/font-awesome",
          name: "Icons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "coreui-icons",
              name: "CoreUI Icons",
              component: CoreUIIcons,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
            {
              path: "font-awesome",
              name: "Font Awesome",
              component: FontAwesome,
            },
            {
              path: "simple-line-icons",
              name: "Simple Line Icons",
              component: SimpleLineIcons,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
      ],
    },
    {
      path: "/admin",
      redirect: "/admin/org/List",
      name: "Admin",
      component: DefaultContainer,
      meta: { authRequired: true },
      // component: CreateOrg,
      children: [
        {
          path: "org/List",
          name: "조직목록",
          component: ListOrg,
        },
        {
          path: "org/Create",
          name: "조직등록",
          component: CreateOrg,
        },
        {
          path: '/admin/org/Edit/:id',
          name: '조직수정',
          component: CreateOrg,
          props: true // 라우트 파라미터를 컴포넌트의 prop으로 사용
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },
    {
      path: "*",
      redirect: "/pages",
      // 아래처럼 바로 NotFound 경로를 매칭해도 됨
      // component: NotFound
    },
  ],
});
